import firebase from '../actions/firebase';

export default firebase.storage();



// WEBPACK FOOTER //
// ./src/actions/storage.js